export default __webpack_public_path__ + "static/media/event5.149b24fe.png";